import http from '../utils/http'

export default {
  checkLogin: () => http.get('/film/checkUserLogin'),
  getCaptcha: () => http.get('/film/getCaptcha'),
  login: (data) => http.post('/film/login', data),
  getMenus: () => http.get('/film/categoriesInAppMenu'),
  getFilms: data => http.post('/film/films', data),
  getFilm: data => http.post('/film/film', data),
  getComments: data => http.post('/film/commentQty', data),
  postComment: data => http.post('/film/postComment', data)
}
